import React, { FC } from 'react';
import { PositionViewType } from '@hub/features/account-dashboard/types';
import { Stack } from '@monorepo/nova-ui';
import { HeaderLeftSection } from './header-left-section';
import { HeaderRightSection } from './header-right-section';

interface TradesTableHeaderProps {
  selectedViews: PositionViewType;
  onSelectionChange: (view: PositionViewType) => void;
}

export const TradesTableHeader: FC<TradesTableHeaderProps> = ({
  selectedViews,
  onSelectionChange,
}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <HeaderLeftSection />
      <HeaderRightSection
        selectedViews={selectedViews}
        onSelectionChange={onSelectionChange}
      />
    </Stack>
  );
};
